import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="company_news" />;

export const Route = createFileRoute("/zh-cn/news/$slug")({
  loader: ({ params }) => loadContentMeta("company_news", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/news/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

